export default __webpack_public_path__ + "static/media/H_Harpa.fd151216.mp3";